import axios from 'axios';
import { downloadFromS3 } from '@/helpers/axiosS3Downloader';

export const defaultState = {
  security: {
    list: [],
    listLoading: false,
    listMinimal: [],
    types: {},
  },
};

export const mutations = {
  SECURITY_SET_LIST(state, list) {
    state.security.list = list;
  },
  SECURITY_SET_LIST_LOADING(state, isLoading) {
    state.security.listLoading = isLoading;
  },
  SECURITY_SET_LIST_MINIMAL(state, list) {
    state.security.listMinimal = list;
  },
  SECURITY_SET_TYPES(state, types) {
    state.security.types = types;
  },
};

export const getters = {
  getSecuritiesList: state => state.security.list,
  getSecuritiesListMinimal: state => state.security.listMinimal,
  getSecurityTypes: state => state.security.types,
};

export const actions = {
  // eslint-disable-next-line no-unused-vars
  callPatSecurityImportCSV({ dispatch }, file) {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/security/import/csv`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(result => result.data);
  },
  fetchPatSecurityList({ commit }) {
    commit('SECURITY_SET_LIST_LOADING', true);

    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/security`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { securities } = response;
          commit('SECURITY_SET_LIST_LOADING', false);
          commit('SECURITY_SET_LIST', securities);
        });
      })
      .catch((error) => {
        commit('SECURITY_SET_LIST_LOADING', false);
        commit('SECURITY_SET_LIST', []);

        return Promise.reject(error);
      });
  },
  fetchPatSecurityListMinimal({ commit }) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/security/list/minimal`)
      .then(({ data }) => {
        downloadFromS3(data).then((response) => {
          const { securities } = response;
          commit('SECURITY_SET_LIST_MINIMAL', securities);
        });
      })
      .catch((error) => {
        commit('SECURITY_SET_LIST_MINIMAL', []);

        return Promise.reject(error);
      });
  },
  fetchPatSecurityAll({ dispatch }) {
    dispatch('fetchPatSecurityList');
  },
  createPatSecurity({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.PAYOUT_AND_TAXES}/security`, payload)
      .then((data) => {
        dispatch('fetchPatSecurityAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  updatePatSecurity({ dispatch }, payload) {
    const { id } = payload;

    return axios.put(`${window.BASE_API.PAYOUT_AND_TAXES}/security/${id}`, payload)
      .then((data) => {
        dispatch('fetchPatSecurityAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  deletePatSecurity({ dispatch }, userId) {
    return axios.delete(`${window.BASE_API.PAYOUT_AND_TAXES}/security/${userId}`)
      .then((data) => {
        dispatch('fetchPatSecurityAll');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
  fetchSecurityTypes({ commit }) {
    return axios.get(`${window.BASE_API.PAYOUT_AND_TAXES}/security/types`)
      .then(({ data }) => {
        commit('SECURITY_SET_TYPES', data);

        return data.data;
      })
      .catch((error) => {
        commit('SECURITY_SET_TYPES', {});

        return Promise.reject(error);
      });
  },
};

const security = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default security;



// WEBPACK FOOTER //
// ./src/store/payout/security.js